<!-- Campana Notifiche PEC -->
<div class="pec-notification-bell"
     [class.shaking]="isShaking"
     [class.has-notifications]="notificationCount > 0"
     [class.disconnected]="!isConnected">

  <button
    pButton
    type="button"
    class="p-button-text p-button-rounded bell-button"
    [pTooltip]="getTooltip()"
    tooltipPosition="bottom"
    (click)="togglePanel()">

    <!-- Icona Campana -->
    <div class="bell-icon-container">
      <app-material-icon
        iconName="notifications"
        [outlined]="notificationCount === 0"
        [size]="24"
        [color]="getBellColor()">
      </app-material-icon>

      <!-- Badge Contatore -->
      <span
        *ngIf="notificationCount > 0"
        class="notification-badge"
        [class.pulsing]="isPulsing">
        {{ notificationCount > 99 ? '99+' : notificationCount }}
      </span>

      <!-- Indicatore Connessione (pulse dot) -->
    <!--   <span
        *ngIf="isConnected && notificationCount === 0"
        class="connection-indicator">
      </span> -->
    </div>
  </button>
</div>

<!-- Pannello Notifiche (integrato) -->
<app-pec-notification-panel
  [(visible)]="showPanel">
</app-pec-notification-panel>

